export enum ProjectStates {
    LEAD = 'lead',
    OFFER = 'offer',
    ORDER = 'order',
    REQUEST = 'request',
}
